import { cssOnSiteSelectors } from '../previews/cssTemp';

/**
 * Helpers for OnSite Advanced CSS.
 * Do NOT auto-inject template CSS on save — the API validates advancedCss and
 * rejects newer properties (e.g. aspect-ratio) with
 * "Invalid css in advanced theme".
 */

function normalizeCss(css) {
  return String(css || '')
    .replace(/\s+/g, ' ')
    .trim();
}

function resolveOnSiteCssKey(layoutType) {
  if (layoutType === 'TEXT_AND_IMAGE') return 'TEXT';
  if (layoutType && cssOnSiteSelectors[layoutType]) return layoutType;
  return 'TEXT';
}

export function getOnSiteDefaultAdvancedCss(
  layoutType,
  cssMap = cssOnSiteSelectors
) {
  const key = resolveOnSiteCssKey(layoutType);
  return cssMap[key] || cssMap.TEXT || '';
}

/** Stock template (or our older silent fix) — treat Advanced Styling as off. */
export function isOnSiteLayoutFixOnly(
  css,
  layoutType,
  cssMap = cssOnSiteSelectors
) {
  if (!css) return false;
  if (String(css).includes('onsite-layout-fix-root')) return true;
  return (
    normalizeCss(css) ===
    normalizeCss(getOnSiteDefaultAdvancedCss(layoutType, cssMap))
  );
}

/**
 * Strip auto-injected / API-rejected CSS so save & preview succeed.
 * Custom Advanced CSS without rejected properties is left unchanged.
 */
export function sanitizeOnSiteAdvancedCss(
  advancedCss,
  layoutType,
  cssMap = cssOnSiteSelectors
) {
  if (!advancedCss) return '';
  if (isOnSiteLayoutFixOnly(advancedCss, layoutType, cssMap)) return '';
  // Backend CSS validator rejects aspect-ratio (seen as "Invalid css in advanced theme").
  if (/aspect-ratio\s*:/i.test(String(advancedCss))) return '';
  return advancedCss;
}
